import { render, staticRenderFns } from "./examEdit.vue?vue&type=template&id=d5c66bd2&scoped=true"
import script from "./examEdit.vue?vue&type=script&lang=js"
export * from "./examEdit.vue?vue&type=script&lang=js"
import style0 from "./examEdit.vue?vue&type=style&index=0&id=d5c66bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c66bd2",
  null
  
)

export default component.exports